import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import { styled } from "@mui/system";

const RootStyle = styled(Box)(({ theme }) => ({
  minWidth: "500px",
  height: "auto",
  background: "#FFFFFF",
  borderRadius: "10px",
  margin: "5px 10px",
  padding: "10px",
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "8px",
    minWidth: "90%",
  },
  [theme.breakpoints.down("xs")]: {
    padding: "8px",
    minWidth: "90%",
  },
}));

const RatingCardSkeleton = () => {
  return (
    <RootStyle>
      <Stack
        width="100%"
        direction={{ md: "row", sx: "column", xs: "column" }}
        spacing={2}
      >
        <Box
          sx={{
            minWidth: "290.9px",
            height: "70px",
            borderRadius: "10px",
            overflow: "hidden",
          }}
        >
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </Box>
        <Box sx={{ minHeight: "62px", borderRadius: "10px", width: "100%" }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height="27px"
            sx={{ mb: 1 }}
          />
          <Skeleton variant="rectangular" width="100%" height="27px" />
        </Box>
      </Stack>
    </RootStyle>
  );
};

export default RatingCardSkeleton;
